<script setup>
import { reactive, ref } from 'vue'
import ManGroup from '../ManGroup.vue'
import { useMetaStore } from '@/stores'
import { down, ensureRef, get, isImgFile, loadEpsgs, post, postMultipart, qsel, validators, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import _ from 'lodash-es'
import { senitizeFileName } from '../../../common/util'
import config from '@/common/config'
import { useRoute,useRouter } from 'vue-router'
import UploadObjdetect from '@/components/UploadObjdetect.vue'
const metaStore=useMetaStore(),mangroup=ref(null),route=useRoute(),router=useRouter()
  ,meta=reactive({epsgs:[-1],selgroup:null,initobjdetect:{layertype:'Point',inputtype:'directinput',epsg:4326,groupid:'defaultgroups',encoding:'UTF-8',etc:null},selapigroup:null
  ,layertypes:['Point','LineString','Polygon'],inputtypes:['directinput','uploadfile'],tartbl:'Objdetect',tblheight:400,data:{rows:[]}
  ,search:{page:1,size:20,sortcol:'mdt',isasc:false,where:{nm:'',groupid_eq_:null}},heads:[{tk:'layertype',col:'layertype'},{tk:'name',col:'nm'},{tk:'coordinatesystem',col:'epsg'},{tk:'dateofmod',col:'mdt'}]
  ,downparam:{service:'',format:'',bbox:'',selservice:'WFS'}
  ,layerfiletypes:[{ext:'zip',type:'vector'},{ext:'geojson',type:'vector'},{ext:'json',type:'vector'},{ext:'gpx',type:'vector'},{ext:'kml',type:'vector'},{ext:'csv',type:'vector'}
    ,{ext:'jpg',type:'raster'},{ext:'png',type:'raster'},{ext:'gif',type:'raster'},{ext:'tif',type:'raster'}],imgupfiletype:'zip',imgupfiles:[]})
,inputfile=ref(null)
,pop=async (type,od)=>{
  meta.poptype=null
  meta.selod=od;
  let persist=false
  if(type=='add'){
    meta.addoverlay=null
    meta.newobjdetect={...meta.initobjdetect}
    meta.newobjdetect.groupid=meta.selgroup?meta.selgroup.id:'defaultgroups'
    persist=true
  }
  if(type=='down'){
    meta.downparam.service='wfs'
    meta.downparam.selservice=meta.downparam.service.toUpperCase()
    meta.capa=await get('rest/authed/member/capabilities/'+meta.downparam.service+'/1.1.1')
    meta.capa=meta.capa.data
    meta.downparam.wfsoutformats=[]
    if(meta.downparam.service=='wfs'){
      meta.selbbox=meta.capa.FeatureTypeList.FeatureType.find(ft=>ft.Name.endsWith(meta.selod.gslayernm)).WGS84BoundingBox
      meta.selbbox=[...meta.selbbox.LowerCorner.split(' '),...meta.selbbox.UpperCorner.split(' ')]
      meta.downparam.format='csv'
      meta.downparam.wfsoutformats=meta.capa.OperationsMetadata.Operation.find(item=>item.name=='GetFeature').Parameter.find(item=>item.name=='outputFormat')
      meta.selbbox.forEach((val,idx)=>meta.selbbox[idx]=parseFloat(val))
    }else{
      meta.selbbox=meta.capa.Capability.Layer.Layer.find(ft=>ft.Name.endsWith(meta.selod.gslayernm)).LatLonBoundingBox
      meta.selbbox=[parseFloat(meta.selbbox.minx),parseFloat(meta.selbbox.miny),parseFloat(meta.selbbox.maxx),parseFloat(meta.selbbox.maxy)]
      meta.downparam.format='image/gif'
    }
  }
  metaStore.pop({ison:type!=null,persist,callback:()=>meta.poptype=type})
},delObjdetect=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/delobjdetect',{id:meta.delid})
  delete meta.delid
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  search()
},uploadToast=(postdata,isupimgs)=>{
  meta.addoverlay='loading'
   metaStore.toastmaker({component:UploadObjdetect,props:{postdata,isupimgs,onRslt:res=>{
      meta.addoverlay=null
      if(res.isSuccess){
        pop()
        search()
      }
      if(isupimgs){
        if(!res.isSuccess)metaStore.toastRslt(res,true)
        else metaStore.toast(res.data.length+'개의 이미지 업로드 완료\n'+res.data,true)
      }else{
        metaStore.toastRslt(res,true)
      }
    }}},{
      position: "top-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
      draggable: false,
      draggablePercent: 0,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon:false
    })
},addObjdetect=async()=>{
  meta.addoverlay='loading'
  if(meta.newobjdetect.groupid=='defaultgroups')meta.newobjdetect.groupid=null
  if(meta.newobjdetect.file){
   uploadToast(meta.newobjdetect,false)
  }else{
    const res=await postMultipart('rest/authed/admin/data/addobjdetect',meta.newobjdetect)
    meta.addoverlay=null
    if(res.isSuccess){
      pop()
      search()
    }
    metaStore.toastRslt(res,true)
  }
},upimgs=()=>{
  uploadToast({id:meta.selod.id,files:meta.imgupfiles},true)
},toEdit=(id)=>{
  metaStore.searchParams.objdetect={...meta.search}
  router.push({path: '/admin/editod/' + id})
},initGroups=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/member/groups/'+meta.tartbl)
  metaStore.blockLoading(false)
  meta.groups=res.data
  meta.groups.unshift({id:'defaultgroups',nm:metaStore.t('defaultgroups'),tartbl:meta.tartbl})
},selFile=file=>{
  if(!file||file.size==0){
    meta.newobjdetect.file=null
    return
  }
  const exts=meta.layerfiletypes.filter(ft=>ft.type=='vector').map(ft=>'.'+ft.ext)
  if(!exts.some(ext=>file.name.toLowerCase().endsWith(ext))){
    meta.newobjdetect.file=null
    metaStore.toastKey('theresaproblemwiththefileyouuploaded',false)
    qsel(inputfile.value.$el,'.mdi-close-circle').click()
    return
  }
  if(meta.newobjdetect.layertype=='Polygon'&&file.name.toLowerCase().endsWith('.gpx')){
    meta.newobjdetect.file=null
    metaStore.toastKey('notallowgpxonpolygon',false)
    qsel(inputfile.value.$el,'.mdi-close-circle').click()
    return
  }
  meta.newobjdetect.file=file
},wfsUrl=({
  service = 'WFS',
  version = '1.0.0',
  request = 'GetFeature',
  typeName = 'sample_line',
  maxFeatures = 99999,
  outputFormat = 'csv',
})=>{
  return `${service.toLowerCase()}?` +
    `service=${encodeURIComponent(service)}&` +
    `version=${encodeURIComponent(version)}&` +
    `request=${encodeURIComponent(request)}&` +
    `typeName=${encodeURIComponent(typeName)}&` +
    `maxFeatures=${encodeURIComponent(maxFeatures)}&` +
    `outputFormat=${encodeURIComponent(outputFormat)}`;
},wmsUrl=({
  service = 'WMS',
  version = '1.1.1',
  request = 'GetMap',
  layers = 'sample_line',
  bbox = '126.66835840124814,33.47583311800146,129.39935145587728,37.8336686864713',
  width = 1024,
  height = 768,
  srs = 'EPSG:4326',
  format = 'image/gif',
})=>{
  return `${service.toLowerCase()}?` +
  `service=${encodeURIComponent(service)}&` +
  `version=${encodeURIComponent(version)}&` +
  `request=${encodeURIComponent(request)}&` +
  `layers=${encodeURIComponent(layers)}&` +
  `bbox=${encodeURIComponent(bbox)}&` +
  `width=${encodeURIComponent(width)}&` +
  `height=${encodeURIComponent(height)}&` +
  `srs=${encodeURIComponent(srs)}&` +
  `format=${encodeURIComponent(format)}`;
},downFile=group=>{
  let url=wmsUrl({layers:meta.selod.gslayernm,bbox:meta.selbbox.toString(),format:meta.downparam.format})
  if(meta.downparam.selservice=='WFS')url=wfsUrl({typeName:meta.selod.gslayernm,outputFormat:meta.downparam.format})
  down({url:url,method:'get'})
  pop()
  metaStore.toastKey('start_download')
},groupSelected=group=>{
  meta.selgroup=group
  meta.search.where.groupid_eq_=group?group.id:null
  meta.search.page=1
  search()
  initGroups()
},search=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/member/searchobjdetect',meta.search)
  metaStore.blockLoading(false)
  meta.data=res.data
  meta.tblheight=window.innerHeight-380
}
if(metaStore.searchParams.objdetect){
  meta.search={...metaStore.searchParams.objdetect}
  metaStore.searchParams.objdetect=null
}
loadEpsgs(epsgs=>epsgs.forEach(epsg=>meta.epsgs.push(epsg)))
search()
</script>
<template>
  <div class="manod">
    <v-row no-gutters w class="h-100 flex-nowrap">
      <v-col style="max-width: 485px;">
        <ManGroup ref="mangroup" :tartbl="meta.tartbl" :ispop="false" :usedefaultgroup="true" @on-sel="groupSelected" @on-search="groupSelected"/>
      </v-col>
      <v-col class="odtblcol">
        <v-card flat :title="meta.selgroup?meta.selgroup.nm:$t('defaultgroups')">
          <v-row>
            <v-col cols="6"><v-text-field hide-details variant="outlined" density="compact" class="ms-3" :label="$t('name')" :placeholder="$t('enteraname')" v-model="meta.search.where.nm"/></v-col>
            <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/></v-col>
            <v-col class="text-right pe-7"><v-btn color="primary" :text="$t('newregistration')" @click="pop('add')"/></v-col>
          </v-row>
          <v-card-text>
            <v-table class="odtbl" fixed-header :height="meta.tblheight">
              <thead>
                <tr>
                  <th class="text-no-wrap" v-for="head in meta.heads">{{ $t(head.tk) }}</th>
                  <th>{{ $t('uploadimgset') }}</th>
                  <th>{{ $t('viewdetails') }}</th>
                  <th>{{ $t('download') }}</th>
                  <th>{{ $t('delete') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in meta.data.rows">
                  <td v-for="head in meta.heads" class="text-no-wrap">
                    <div v-if="head.col=='mdt'">{{ ymd(row.mdt) }}</div>
                    <div v-else-if="head.col=='layertype'">{{ $t(row[head.col].replace('Multi',''))}}</div>
                    <div v-else>{{ row[head.col] }}</div>
                  </td>
                  <td class="text-center"><v-btn :text="$t('uploadimgset')" @click="pop('upimgs',row)"/></td>
                  <td class="text-center"><v-btn :text="$t('viewdetails')" @click="toEdit(row.id)"/></td>
                  <td class="text-center"><v-btn v-if="row.gslayernm" prepend-icon="mdi-download-box-outline" color="primary" :text="$t('download')" @click="pop('down',row)"/></td>
                  <td class="text-center"><v-btn color="error" :text="$t('delete')" @click="meta.delid=row.id;metaStore.dialog({shown:true,ttl:'delete',cont:'del_con',showcancel:true,istk:true,onok:delObjdetect})"/></td>
                </tr>
                <tr v-if="!meta.data.rows.length">
                  <td :colspan="meta.heads.length+4" class="text-center">{{ $t('noresultsfound') }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>
          <v-card-actions>
            <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <Teleport v-if="meta.poptype" to="#popbody">
    <v-card flat v-if="meta.poptype=='add'" min-width="450" rounded="0">
      <v-card-title>
        <v-row>
          <v-col align-self="center">{{ $t('newregistration') }}</v-col>
          <v-col cols="2" class="text-right"><v-icon icon="mdi-close" class="cursor-pointer" @click="pop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-alert class="ma-3" style="max-height: calc(100vh - 400px);overflow-y: auto;">
        <v-container fluid>
          <v-defaults-provider :defaults="{VRadioGroup:{inline:true,hideDetails:true}}">
            <div v-for="lbl in ['layertype','inputtype']" class="mb-2">
              <p>{{ $t(lbl) }}</p>
              <v-radio-group v-model="meta.newobjdetect[lbl]">
                <v-radio v-for="item in meta[lbl+'s']" :label="$t(item)" :value="item"/>
              </v-radio-group>
            </div>
          </v-defaults-provider>
          <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
            <v-file-input v-if="meta.newobjdetect.inputtype=='uploadfile'" class="mb-4" prepend-icon prepend-inner-icon="mdi-paperclip" :ref="obj=>inputfile=obj" :label="$t('uploadfile')" @update:model-value="selFile"/>
            <v-select class="mb-4" :items="['UTF-8']" v-model="meta.newobjdetect.encoding" :label="$t('encodingtype')"/>
            <v-select class="mb-4" :items="meta.epsgs" v-model="meta.newobjdetect.epsg" :label="$t('coordinatesystem')"
              :item-props="item=>item==-1?{title:$t('auto'),value:item}:{title:'EPSG:'+item,value:item}"/>
          </v-defaults-provider>
          <v-row no-gutters class="mb-4">
            <v-col>
              <v-select hide-details variant="outlined" density="compact" :items="meta.groups" v-model="meta.newobjdetect.groupid" :label="$t('groupname')" :item-props="item=>({title:item.nm,value:item.id})"/>
            </v-col>
            <v-col cols="3" class="text-right"><v-btn variant="outlined" size="40" :prepend-icon="meta.newobjdetect.etc===null?'mdi-plus':'mdi-minus'" @click="meta.newobjdetect.etc=meta.newobjdetect.etc!=null?null:''"/></v-col>
          </v-row>
          <v-row no-gutters v-if="meta.newobjdetect.etc!=null">
            <v-col><v-text-field variant="outlined" density="compact" :label="$t('newgroupname')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.newobjdetect.etc"/></v-col>
          </v-row>
          <v-text-field variant="outlined" density="compact" v-model="meta.newobjdetect.nm" :label="$t('name')" maxlength="50" :rules="[validators.required]" @update:model-value="val=>meta.newobjdetect.nm=senitizeFileName(val)"/>
        </v-container>
      </v-alert>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn color="error" variant="elevated" class="me-3" :text="$t('cancel')" @click="pop()"/>
            <v-btn color="primary" variant="elevated" class="me-1" :text="$t('save')"
              :disabled="_.isEmpty(meta.newobjdetect.nm)||(meta.newobjdetect.inputtype=='uploadfile'&&meta.newobjdetect.file==null)" @click="meta.addoverlay='con'"/>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-overlay contained :model-value="meta.addoverlay!=null" class="align-center justify-center" persistent>
        <ConfirmCard v-if="meta.addoverlay=='con'" :ttl="$t('newregistration')" cont="save" @cancel="meta.addoverlay=null" @confirm="()=>{
          if(meta.poptype=='add')addObjdetect()
        }"/>
        <v-progress-circular v-if="meta.addoverlay=='loading'" color="primary" size="64" indeterminate/>
      </v-overlay>
    </v-card>
    <v-card v-if="meta.poptype=='down'" min-width="290">
      <v-card-title>
        <v-row>
          <v-col cols="9">{{ $t('download')+' '+$t('file') }}</v-col>
          <v-col class="text-right"><v-btn size="34" variant="text" density="compact" icon="mdi-close" @click="pop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-select hide-details variant="outlined" density="compact" class="mb-3" :items="meta.downparam.service=='wfs'?['WMS','WFS']:['WMS']" v-model="meta.downparam.selservice"
          @update:model-value="val=>meta.downparam.format=(meta.downparam.service=='wms'?config.WmsDownloadFormats:config.WfsDownloadFormats)[val][0].value"/>
        <v-select hide-details variant="outlined" density="compact" class="mb-3" :items="(meta.downparam.selservice=='WMS'?config.WmsDownloadFormats:config.WfsDownloadFormats)[meta.downparam.selservice]" v-model="meta.downparam.format"/>
        <v-btn block prepend-icon="mdi-download-box-outline" color="primary" class="mb-3" :text="$t('download')" @click="downFile"/>
      </v-card-text>
    </v-card>
    <v-card v-if="meta.poptype=='upimgs'" min-width="290">
      <v-card-title>
        <v-row>
          <v-col cols="9">{{ $t('uploadimgset') }}</v-col>
          <v-col class="text-right"><v-btn size="34" variant="text" density="compact" icon="mdi-close" @click="pop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3" align-self="center">{{$t('select_type')}}</v-col>
          <v-col>
            <v-radio-group hide-details variant="outlined" density="compact" v-model="meta.imgupfiletype" inline @update:model-value="()=>{
                const fileinput=qsel('[name=imgfiles]');
                if(fileinput)fileinput.value='';
                meta.imgupfiles=[];
              }">
              <v-radio label="폴더" value="dir"></v-radio>
              <v-radio label="ZIP파일" value="zip"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" align-self="center">{{$t('fileattachments')}}:</v-col>
          <v-col>
            <input type="file" name="imgfiles" class="w-100" @change="evt=>meta.imgupfiles=Array.from(evt.target.files)"
            :webkitdirectory="meta.imgupfiletype=='dir'?'':undefined" :directory="meta.imgupfiletype=='dir'?'':undefined" :multiple="meta.imgupfiletype=='dir'?'':undefined" :accept="meta.imgupfiletype=='zip'?'.zip':undefined"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn color="error" variant="elevated" class="me-3" :text="$t('cancel')" @click="pop()"/>
            <v-btn color="primary" variant="elevated" class="me-1" :text="$t('save')" @click="upimgs()"
              :disabled="!meta.imgupfiles||meta.imgupfiles.length==0"/>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
.odtblcol{width: 200px;}
.odtblcol > .v-card{max-width: calc(100vw - 420px);}
.rastercoords .v-number-input__control button{border-width: 0 !important;}
.odtbl{border: 1px solid #e0e0e0;margin-top: 18px;}
.odtbl th{background-color: #eee !important;text-align: center !important; max-width: 180px;}
.odtbl td{text-align: center;}
</style>
